/** @jsx jsx */

import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';

const { lGrey1 } = colors;

// viewBox="0 0 360 360"
const GraphBar = ({ color = '#F6306B', score }) => {
  const [animatedValue, setAnimatedValue] = useState(Math.random());
  const mounted = useRef(true);

  useEffect(() => {
    if (!window.dev()) {
      return;
    }

    const tick = setTimeout(() => {
      if (mounted.current) {
        clearTimeout(tick);
        setAnimatedValue(Math.random());
      }
    }, 3000);
  }, [animatedValue]);

  useEffect(() => () => (mounted.current = false), []);

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 0 0 50px 0;
      `}
    >
      <div
        css={css`
          width: 100%;
          max-width: 360px;
          height: 30px;
          padding: 3px;
          border-radius: 9999px;
          background: ${lGrey1};
        `}
      >
        <div
          css={css`
            width: ${window.dev() ? 100 * animatedValue : score}%;
            height: 100%;
            border-radius: 9999px;
            background: ${color};
            transition: all 0.3s;
          `}
        />

        <div
          css={css`
            // position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            // left: 0;
            // top: 0;
            width: 100%;
            // height: 100%;
            margin: 10px;
          `}
        >
          <h1>{window.dev() ? Math.ceil(animatedValue * 100) : score}%</h1>
        </div>
      </div>
    </div>
  );
};

export default GraphBar;
